import { useCurrentClub } from '@/hooks/use-current-club';
import { MissingData } from '@/components/control-panel/missing-data';
import { QuickActions } from '@/components/control-panel/quick-actions';
import { urlControlPanel } from '@/urls';
import { StatsCard } from '@repo/ui/components/stats-card';
import { clubApi } from '@repo/api-client';
import { LoaderFunctionArgs, useLoaderData } from 'react-router';
import { DollarSign, Package, ShoppingCart, Users } from 'lucide-react';
import { tennisBall } from '@lucide/lab';

const icons = {
  Package: Package,
  ShoppingCart: ShoppingCart,
  DollarSign: DollarSign,
  TennisBall: tennisBall,
  Users: Users,
};

function ControlPanel() {
  const stats = useLoaderData<typeof route.loader>();
  const club = useCurrentClub();
  return (
    <div className="flex flex-col gap-6">
      <MissingData club={club} />

      <QuickActions club={club} />

      <div>
        <h2 className="text-lg font-semibold mb-3">Estadísticas</h2>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {stats.map((stat) => (
            <StatsCard
              key={stat.label}
              title={stat.label}
              className="col-span-1"
              description1={stat.description}
              icon={icons[stat.icon as keyof typeof icons]}
            >
              {stat.value}
            </StatsCard>
          ))}
        </div>
      </div>
    </div>
  );
}

export const route = {
  path: urlControlPanel(':id'),
  element: <ControlPanel />,
  handle: {
    title: 'Panel de control',
  },
  loader: async ({ params }: LoaderFunctionArgs) => {
    return await clubApi.getStats(params.id as string);
  },
};
